import { useQuery } from "react-query"
import { useParams } from "react-router-dom"
import { analyticsQueryKey } from "../lib/refresh"
import { axios } from "../lib/request"


/**
 * Fetches team and player analytics data for a specific game.
 * 
 * @param {string} game_id - The unique identifier of the game.
 * @returns {Promise<Object>} The analytics data payload from the API.
 */
export const fetchTeamAnalytics = async (game_id) => {
    const response = await axios({
        url: process.env.REACT_APP_API_ANALYTICS_TEAMS_URL,
        params: { game_id },
    })
    return response?.data
}

/**
 * A React Query hook that manages the fetching and caching of game analytics.
 * Automatically extracts the `game_id` from the URL parameters.
 * 
 * @returns {import("react-query").UseQueryResult} The query result object containing the analytics data and fetching state.
 */
export const useAnalyticsQuery = () => {
    const { game_id } = useParams();
    return useQuery(
        analyticsQueryKey(game_id),
        () => fetchTeamAnalytics(game_id),
    )
}